// extracted by mini-css-extract-plugin
module.exports = {"QuoteList":"QuoteList_QuoteList__2YwK7"};